export const thresolds: {[key: string]: number} = {k: 10, s: 100, c: 3, m: 100};

export const wScreen =
  'relative md:w-[100cqw] md:left-1/2 md:right-1/2 md:-ml-[50cqw] -mx-4';
